// Build a WhatsApp click-to-chat URL with pre-filled order details.
const WA_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "";

export function buildWhatsAppOrderUrl({ order, orderId }) {
  const lines = [];
  lines.push("*New Order — Lineacraft India*");
  if (orderId) lines.push(`Order ID: ${String(orderId).toUpperCase()}`);
  lines.push("");
  lines.push("*Customer*");
  lines.push(`Name: ${order.customerName}`);
  lines.push(`Phone: ${order.phone}`);
  if (order.email) lines.push(`Email: ${order.email}`);
  lines.push("");
  lines.push("*Shipping Address*");
  lines.push(order.address);
  lines.push(`${order.city}, ${order.state} - ${order.pincode}`);
  if (order.notes) lines.push(`Notes: ${order.notes}`);
  lines.push("");
  lines.push("*Items*");
  order.items.forEach((it, i) => {
    const v = it.variantTag && it.variantTag !== "Default" ? ` [${it.variantTag}]` : "";
    lines.push(`${i + 1}. ${it.name}${v} × ${it.quantity} = ₹${it.price * it.quantity}`);
  });
  lines.push("");
  if (order.subtotal) lines.push(`Subtotal: ₹${order.subtotal}`);
  if (order.shippingCharge > 0) {
    lines.push(`Shipping Charge: ₹${order.shippingCharge}`);
  } else {
    lines.push(`Shipping Charge: FREE`);
  }
  if (Number(order.codCharge || 0) > 0 || order.paymentType === "COD" || order.paymentMethod?.includes("COD")) {
    if (Number(order.codCharge || 0) > 0) {
      lines.push(`COD Charge: ₹${order.codCharge}`);
    }
    lines.push(`Payment Method: Cash on Delivery (COD)`);
    lines.push(`*Grand Total: ₹${order.total}*`);
    const adv = order.advancePaid != null ? Number(order.advancePaid) : Math.min(100, Number(order.total || 0));
    const bal = order.codBalanceDue != null ? Number(order.codBalanceDue) : Math.max(0, Number(order.total || 0) - adv);
    lines.push(`• Advance to Pay Now: ₹${adv} (Prepaid to confirm order)`);
    lines.push(`• Balance on Delivery: ₹${bal} (Pay cash to courier)`);
  } else {
    if (order.paymentMethod) {
      lines.push(`Payment Method: ${order.paymentMethod}`);
    }
    lines.push(`*Grand Total: ₹${order.total}*`);
  }
  if (orderId || order.id) {
    const id = orderId || order.id;
    lines.push("");
    lines.push(`*Track Shipment:* ${window.location.origin}/track/${id}`);
  }
  lines.push("");
  lines.push("Please confirm payment details and shipping ETA. Thank you!");
  const text = encodeURIComponent(lines.join("\n"));
  return `https://wa.me/${WA_NUMBER}?text=${text}`;
}

export function buildWhatsAppInquiryUrl(text = "Hi Lineacraft, I'd like to know more about your products.") {
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
}
